export const GeneralIcon = ({
  className = "",
  width = "40",
  height = "40",
}) => (
  <svg
    className={className}
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.875"
      width="40"
      height="40"
      rx="8"
      fill="#F5F5F5"
    />
    <path
      d="M28.8749 16.18V11C28.8749 10.7348 28.7696 10.4804 28.582 10.2929C28.3945 10.1054 28.1401 10 27.8749 10C27.6097 10 27.3553 10.1054 27.1678 10.2929C26.9803 10.4804 26.8749 10.7348 26.8749 11V16.18C26.2958 16.3902 25.7954 16.7736 25.4418 17.2782C25.0881 17.7827 24.8984 18.3839 24.8984 19C24.8984 19.6161 25.0881 20.2173 25.4418 20.7218C25.7954 21.2264 26.2958 21.6098 26.8749 21.82V29C26.8749 29.2652 26.9803 29.5196 27.1678 29.7071C27.3553 29.8946 27.6097 30 27.8749 30C28.1401 30 28.3945 29.8946 28.582 29.7071C28.7696 29.5196 28.8749 29.2652 28.8749 29V21.82C29.4541 21.6098 29.9545 21.2264 30.3081 20.7218C30.6617 20.2173 30.8514 19.6161 30.8514 19C30.8514 18.3839 30.6617 17.7827 30.3081 17.2782C29.9545 16.7736 29.4541 16.3902 28.8749 16.18ZM27.8749 20C27.6771 20 27.4838 19.9414 27.3193 19.8315C27.1549 19.7216 27.0267 19.5654 26.951 19.3827C26.8753 19.2 26.8555 18.9989 26.8941 18.8049C26.9327 18.6109 27.028 18.4327 27.1678 18.2929C27.3077 18.153 27.4858 18.0578 27.6798 18.0192C27.8738 17.9806 28.0749 18.0004 28.2576 18.0761C28.4403 18.1518 28.5965 18.28 28.7064 18.4444C28.8163 18.6089 28.8749 18.8022 28.8749 19C28.8749 19.2652 28.7696 19.5196 28.582 19.7071C28.3945 19.8946 28.1401 20 27.8749 20ZM21.8749 22.18V11C21.8749 10.7348 21.7696 10.4804 21.582 10.2929C21.3945 10.1054 21.1401 10 20.8749 10C20.6097 10 20.3553 10.1054 20.1678 10.2929C19.9803 10.4804 19.8749 10.7348 19.8749 11V22.18C19.2958 22.3902 18.7954 22.7736 18.4418 23.2782C18.0881 23.7827 17.8984 24.3839 17.8984 25C17.8984 25.6161 18.0881 26.2173 18.4418 26.7218C18.7954 27.2264 19.2958 27.6098 19.8749 27.82V29C19.8749 29.2652 19.9803 29.5196 20.1678 29.7071C20.3553 29.8946 20.6097 30 20.8749 30C21.1401 30 21.3945 29.8946 21.582 29.7071C21.7696 29.5196 21.8749 29.2652 21.8749 29V27.82C22.4541 27.6098 22.9545 27.2264 23.3081 26.7218C23.6617 26.2173 23.8514 25.6161 23.8514 25C23.8514 24.3839 23.6617 23.7827 23.3081 23.2782C22.9545 22.7736 22.4541 22.3902 21.8749 22.18ZM20.8749 26C20.6771 26 20.4838 25.9414 20.3193 25.8315C20.1549 25.7216 20.0267 25.5654 19.951 25.3827C19.8753 25.2 19.8555 24.9989 19.8941 24.8049C19.9327 24.6109 20.028 24.4327 20.1678 24.2929C20.3077 24.153 20.4858 24.0578 20.6798 24.0192C20.8738 23.9806 21.0749 24.0004 21.2576 24.0761C21.4403 24.1518 21.5965 24.28 21.7064 24.4444C21.8163 24.6089 21.8749 24.8022 21.8749 25C21.8749 25.2652 21.7696 25.5196 21.582 25.7071C21.3945 25.8946 21.1401 26 20.8749 26ZM14.8749 14.18V11C14.8749 10.7348 14.7696 10.4804 14.582 10.2929C14.3945 10.1054 14.1401 10 13.8749 10C13.6097 10 13.3553 10.1054 13.1678 10.2929C12.9803 10.4804 12.8749 10.7348 12.8749 11V14.18C12.2958 14.3902 11.7954 14.7736 11.4418 15.2782C11.0881 15.7827 10.8984 16.3839 10.8984 17C10.8984 17.6161 11.0881 18.2173 11.4418 18.7218C11.7954 19.2264 12.2958 19.6098 12.8749 19.82V29C12.8749 29.2652 12.9803 29.5196 13.1678 29.7071C13.3553 29.8946 13.6097 30 13.8749 30C14.1401 30 14.3945 29.8946 14.582 29.7071C14.7696 29.5196 14.8749 29.2652 14.8749 29V19.82C15.4541 19.6098 15.9545 19.2264 16.3081 18.7218C16.6617 18.2173 16.8514 17.6161 16.8514 17C16.8514 16.3839 16.6617 15.7827 16.3081 15.2782C15.9545 14.7736 15.4541 14.3902 14.8749 14.18ZM13.8749 18C13.6771 18 13.4838 17.9414 13.3193 17.8315C13.1549 17.7216 13.0267 17.5654 12.951 17.3827C12.8753 17.2 12.8555 16.9989 12.8941 16.8049C12.9327 16.6109 13.028 16.4327 13.1678 16.2929C13.3077 16.153 13.4858 16.0578 13.6798 16.0192C13.8738 15.9806 14.0749 16.0004 14.2576 16.0761C14.4403 16.1518 14.5965 16.28 14.7064 16.4444C14.8163 16.6089 14.8749 16.8022 14.8749 17C14.8749 17.2652 14.7696 17.5196 14.582 17.7071C14.3945 17.8946 14.1401 18 13.8749 18Z"
      fill="#333333"
    />
  </svg>
);

export const BlockIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.625"
      width="40"
      height="40"
      rx="8"
      fill="#F5F5F5"
    />
    <path
      d="M29.625 10H17.625C17.3598 10 17.1054 10.1054 16.9179 10.2929C16.7304 10.4804 16.625 10.7348 16.625 11V15H14.625C14.3598 15 14.1054 15.1054 13.9179 15.2929C13.7304 15.4804 13.625 15.7348 13.625 16V20H11.625C11.3598 20 11.1054 20.1054 10.9179 20.2929C10.7304 20.4804 10.625 20.7348 10.625 21V29C10.625 29.2652 10.7304 29.5196 10.9179 29.7071C11.1054 29.8946 11.3598 30 11.625 30H19.625C19.8902 30 20.1446 29.8946 20.3321 29.7071C20.5196 29.5196 20.625 29.2652 20.625 29V27H24.625C24.8902 27 25.1446 26.8946 25.3321 26.7071C25.5196 26.5196 25.625 26.2652 25.625 26V24H29.625C29.8902 24 30.1446 23.8946 30.3321 23.7071C30.5196 23.5196 30.625 23.2652 30.625 23V11C30.625 10.7348 30.5196 10.4804 30.3321 10.2929C30.1446 10.1054 29.8902 10 29.625 10ZM18.625 28H12.625V22H18.625V28ZM23.625 25H20.625V21C20.625 20.7348 20.5196 20.4804 20.3321 20.2929C20.1446 20.1054 19.8902 20 19.625 20H15.625V17H23.625V25ZM28.625 22H25.625V16C25.625 15.7348 25.5196 15.4804 25.3321 15.2929C25.1446 15.1054 24.8902 15 24.625 15H18.625V12H28.625V22Z"
      fill="#333333"
    />
  </svg>
);

export const BackgroundIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="22"
      height="22"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M17.4163 3.66577H4.58301C3.85366 3.66577 3.15419 3.9555 2.63846 4.47123C2.12274 4.98695 1.83301 5.68643 1.83301 6.41577V15.5824C1.83301 16.3118 2.12274 17.0113 2.63846 17.527C3.15419 18.0427 3.85366 18.3324 4.58301 18.3324H17.4163C18.1457 18.3324 18.8452 18.0427 19.3609 17.527C19.8766 17.0113 20.1663 16.3118 20.1663 15.5824V6.41577C20.1663 5.68643 19.8766 4.98695 19.3609 4.47123C18.8452 3.9555 18.1457 3.66577 17.4163 3.66577ZM4.58301 16.4991C4.33989 16.4991 4.10674 16.4025 3.93483 16.2306C3.76292 16.0587 3.66634 15.8256 3.66634 15.5824V13.3641L6.69134 10.3483C6.86269 10.1803 7.09307 10.0862 7.33301 10.0862C7.57295 10.0862 7.80332 10.1803 7.97467 10.3483L14.1255 16.4991H4.58301ZM18.333 15.5824C18.333 15.8256 18.2364 16.0587 18.0645 16.2306C17.8926 16.4025 17.6595 16.4991 17.4163 16.4991H16.7105L13.218 12.9883L14.0247 12.1816C14.196 12.0136 14.4264 11.9196 14.6663 11.9196C14.9063 11.9196 15.1367 12.0136 15.308 12.1816L18.333 15.1974V15.5824ZM18.333 12.6124L16.6097 10.8983C16.0872 10.3963 15.3908 10.116 14.6663 10.116C13.9418 10.116 13.2455 10.3963 12.723 10.8983L11.9163 11.7049L9.27634 9.06494C8.75389 8.563 8.0575 8.28268 7.33301 8.28268C6.60851 8.28268 5.91212 8.563 5.38967 9.06494L3.66634 10.7791V6.41577C3.66634 6.17266 3.76292 5.9395 3.93483 5.76759C4.10674 5.59568 4.33989 5.4991 4.58301 5.4991H17.4163C17.6595 5.4991 17.8926 5.59568 18.0645 5.76759C18.2364 5.9395 18.333 6.17266 18.333 6.41577V12.6124Z"
      fill="#333333"
    />
  </svg>
);

export const HeaderIcon = ({ className = "" }) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.375 6C15.2437 5.99997 15.1136 6.02581 14.9923 6.07605C14.8709 6.12629 14.7607 6.19995 14.6678 6.29282C14.575 6.38568 14.5013 6.49593 14.4511 6.61728C14.4008 6.73862 14.375 6.86867 14.375 7V11H10.375V7C10.375 6.73478 10.2696 6.48043 10.0821 6.29289C9.89457 6.10536 9.64022 6 9.375 6C9.10978 6 8.85543 6.10536 8.66789 6.29289C8.48036 6.48043 8.375 6.73478 8.375 7V17C8.375 17.2652 8.48036 17.5196 8.66789 17.7071C8.85543 17.8946 9.10978 18 9.375 18C9.64022 18 9.89457 17.8946 10.0821 17.7071C10.2696 17.5196 10.375 17.2652 10.375 17V13H14.375V17C14.375 17.2652 14.4804 17.5196 14.6679 17.7071C14.8554 17.8946 15.1098 18 15.375 18C15.6402 18 15.8946 17.8946 16.0821 17.7071C16.2696 17.5196 16.375 17.2652 16.375 17V7C16.375 6.86867 16.3492 6.73862 16.2989 6.61728C16.2487 6.49593 16.175 6.38568 16.0822 6.29282C15.9893 6.19995 15.8791 6.12629 15.7577 6.07605C15.6364 6.02581 15.5063 5.99997 15.375 6ZM19.375 2H5.375C4.57962 2.00087 3.81706 2.31722 3.25464 2.87964C2.69222 3.44206 2.37587 4.20462 2.375 5V19C2.37587 19.7954 2.69222 20.5579 3.25464 21.1204C3.81706 21.6828 4.57962 21.9991 5.375 22H19.375C20.1704 21.9991 20.9329 21.6828 21.4954 21.1204C22.0578 20.5579 22.3741 19.7954 22.375 19V5C22.3741 4.20462 22.0578 3.44206 21.4954 2.87964C20.9329 2.31722 20.1704 2.00087 19.375 2ZM20.375 19C20.3747 19.2651 20.2693 19.5193 20.0818 19.7068C19.8943 19.8943 19.6401 19.9997 19.375 20H5.375C5.10986 19.9997 4.85566 19.8943 4.66819 19.7068C4.48071 19.5193 4.37526 19.2651 4.375 19V5C4.37526 4.73486 4.48071 4.48066 4.66819 4.29319C4.85566 4.10571 5.10986 4.00026 5.375 4H19.375C19.6401 4.00026 19.8943 4.10571 20.0818 4.29319C20.2693 4.48066 20.3747 4.73486 20.375 5V19Z"
      fill="#333333"
    />
  </svg>
);

export const HeaderIconV2 = ({ className = "" }) => (
  <svg
    className={className}
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.375"
      width="40"
      height="40"
      rx="8"
      fill="#F5F5F5"
    />
    <path
      d="M23.375 14C23.2437 14 23.1136 14.0258 22.9923 14.0761C22.8709 14.1263 22.7607 14.2 22.6678 14.2928C22.575 14.3857 22.5013 14.4959 22.4511 14.6173C22.4008 14.7386 22.375 14.8687 22.375 15V19H18.375V15C18.375 14.7348 18.2696 14.4804 18.0821 14.2929C17.8946 14.1054 17.6402 14 17.375 14C17.1098 14 16.8554 14.1054 16.6679 14.2929C16.4804 14.4804 16.375 14.7348 16.375 15V25C16.375 25.2652 16.4804 25.5196 16.6679 25.7071C16.8554 25.8946 17.1098 26 17.375 26C17.6402 26 17.8946 25.8946 18.0821 25.7071C18.2696 25.5196 18.375 25.2652 18.375 25V21H22.375V25C22.375 25.2652 22.4804 25.5196 22.6679 25.7071C22.8554 25.8946 23.1098 26 23.375 26C23.6402 26 23.8946 25.8946 24.0821 25.7071C24.2696 25.5196 24.375 25.2652 24.375 25V15C24.375 14.8687 24.3492 14.7386 24.2989 14.6173C24.2487 14.4959 24.175 14.3857 24.0822 14.2928C23.9893 14.2 23.8791 14.1263 23.7577 14.0761C23.6364 14.0258 23.5063 14 23.375 14ZM27.375 10H13.375C12.5796 10.0009 11.8171 10.3172 11.2546 10.8796C10.6922 11.4421 10.3759 12.2046 10.375 13V27C10.3759 27.7954 10.6922 28.5579 11.2546 29.1204C11.8171 29.6828 12.5796 29.9991 13.375 30H27.375C28.1704 29.9991 28.9329 29.6828 29.4954 29.1204C30.0578 28.5579 30.3741 27.7954 30.375 27V13C30.3741 12.2046 30.0578 11.4421 29.4954 10.8796C28.9329 10.3172 28.1704 10.0009 27.375 10ZM28.375 27C28.3747 27.2651 28.2693 27.5193 28.0818 27.7068C27.8943 27.8943 27.6401 27.9997 27.375 28H13.375C13.1099 27.9997 12.8557 27.8943 12.6682 27.7068C12.4807 27.5193 12.3753 27.2651 12.375 27V13C12.3753 12.7349 12.4807 12.4807 12.6682 12.2932C12.8557 12.1057 13.1099 12.0003 13.375 12H27.375C27.6401 12.0003 27.8943 12.1057 28.0818 12.2932C28.2693 12.4807 28.3747 12.7349 28.375 13V27Z"
      fill="#333333"
    />
  </svg>
);

export const TextIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.125"
      width="40"
      height="40"
      rx="8"
      fill="#F5F5F5"
    />
    <path
      d="M20.125 14H17.125C16.8598 14 16.6054 14.1054 16.4179 14.2929C16.2304 14.4804 16.125 14.7348 16.125 15V25C16.125 25.2652 16.2304 25.5196 16.4179 25.7071C16.6054 25.8946 16.8598 26 17.125 26C17.3902 26 17.6446 25.8946 17.8321 25.7071C18.0196 25.5196 18.125 25.2652 18.125 25V22H20.125C21.1859 22 22.2033 21.5786 22.9534 20.8284C23.7036 20.0783 24.125 19.0609 24.125 18C24.125 16.9391 23.7036 15.9217 22.9534 15.1716C22.2033 14.4214 21.1859 14 20.125 14ZM20.125 20H18.125V16H20.125C20.6554 16 21.1641 16.2107 21.5392 16.5858C21.9143 16.9609 22.125 17.4696 22.125 18C22.125 18.5304 21.9143 19.0391 21.5392 19.4142C21.1641 19.7893 20.6554 20 20.125 20ZM27.125 10H13.125C12.3294 10 11.5663 10.3161 11.0037 10.8787C10.4411 11.4413 10.125 12.2044 10.125 13V27C10.125 27.7956 10.4411 28.5587 11.0037 29.1213C11.5663 29.6839 12.3294 30 13.125 30H27.125C27.9206 30 28.6837 29.6839 29.2463 29.1213C29.8089 28.5587 30.125 27.7956 30.125 27V13C30.125 12.2044 29.8089 11.4413 29.2463 10.8787C28.6837 10.3161 27.9206 10 27.125 10ZM28.125 27C28.125 27.2652 28.0196 27.5196 27.8321 27.7071C27.6446 27.8946 27.3902 28 27.125 28H13.125C12.8598 28 12.6054 27.8946 12.4179 27.7071C12.2304 27.5196 12.125 27.2652 12.125 27V13C12.125 12.7348 12.2304 12.4804 12.4179 12.2929C12.6054 12.1054 12.8598 12 13.125 12H27.125C27.3902 12 27.6446 12.1054 27.8321 12.2929C28.0196 12.4804 28.125 12.7348 28.125 13V27Z"
      fill="#333333"
    />
  </svg>
);

export const LinkIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="22"
      height="22"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M9.16644 16.0867L7.54393 17.6634C7.11848 18.0888 6.54145 18.3278 5.93977 18.3278C5.33809 18.3278 4.76105 18.0888 4.3356 17.6634C3.91015 17.2379 3.67113 16.6609 3.67113 16.0592C3.67113 15.4575 3.91015 14.8805 4.3356 14.455L8.49727 10.2842C8.90575 9.87439 9.45612 9.63728 10.0345 9.62192C10.6129 9.60657 11.1751 9.81414 11.6048 10.2017L11.7148 10.2934C11.8886 10.4635 12.1229 10.5577 12.3662 10.5551C12.6094 10.5525 12.8417 10.4534 13.0119 10.2796C13.182 10.1058 13.2762 9.87147 13.2736 9.62822C13.271 9.38497 13.1719 9.15271 12.9981 8.98252C12.9464 8.91563 12.8913 8.85138 12.8331 8.79002C12.0506 8.10923 11.0386 7.7513 10.002 7.78875C8.9655 7.82619 7.98195 8.25621 7.2506 8.99169L3.03394 13.1625C2.31743 13.9424 1.92992 14.969 1.95234 16.0278C1.97475 17.0866 2.40536 18.0959 3.15423 18.8447C3.9031 19.5936 4.91233 20.0242 5.97116 20.0466C7.02999 20.069 8.05654 19.6815 8.83644 18.965L10.4223 17.4159C10.5789 17.245 10.6649 17.0213 10.6632 16.7895C10.6614 16.5578 10.572 16.3354 10.4128 16.1669C10.2537 15.9985 10.0367 15.8966 9.80541 15.8817C9.57416 15.8668 9.34586 15.94 9.16644 16.0867ZM18.9656 3.03336C18.1945 2.26703 17.1515 1.83691 16.0644 1.83691C14.9772 1.83691 13.9342 2.26703 13.1631 3.03336L11.5773 4.58253C11.4207 4.75335 11.3346 4.97713 11.3364 5.20885C11.3381 5.44057 11.4276 5.66303 11.5867 5.83147C11.7458 5.99991 11.9629 6.10182 12.1941 6.1167C12.4254 6.13159 12.6537 6.05834 12.8331 5.91169L14.4189 4.33503C14.8444 3.90957 15.4214 3.67056 16.0231 3.67056C16.6248 3.67056 17.2018 3.90957 17.6273 4.33503C18.0527 4.76048 18.2917 5.33751 18.2917 5.93919C18.2917 6.54087 18.0527 7.11791 17.6273 7.54336L13.4656 11.7142C13.0571 12.124 12.5067 12.3611 11.9283 12.3765C11.3499 12.3918 10.7877 12.1842 10.3581 11.7967L10.2481 11.705C10.0743 11.5348 9.83996 11.4407 9.59671 11.4433C9.35346 11.4458 9.1212 11.5449 8.95102 11.7188C8.78084 11.8926 8.68668 12.1269 8.68926 12.3702C8.69184 12.6134 8.79094 12.8457 8.96477 13.0159C9.03135 13.084 9.10174 13.1482 9.1756 13.2084C9.95905 13.8871 10.9706 14.2437 12.0065 14.2063C13.0424 14.1688 14.0257 13.7402 14.7581 13.0067L18.9289 8.83586C19.7002 8.06959 20.1369 7.02932 20.1437 5.94217C20.1506 4.85502 19.7271 3.80931 18.9656 3.03336Z"
      fill="#333333"
    />
  </svg>
);

export const ButtonIconV2 = ({ className = "" }) => (
  <svg
    className={className}
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.875"
      width="40"
      height="40"
      rx="8"
      fill="#F5F5F5"
    />
    <path
      d="M24.9749 19H16.7749C16.1749 19 15.7749 19.4 15.7749 20C15.7749 20.6 16.1749 21 16.7749 21H25.0749C25.6749 21 26.0749 20.6 26.0749 20C25.9749 19.4 25.5749 19 24.9749 19Z"
      fill="#333333"
    />
    <path
      d="M25.775 14.8999H15.975C13.175 14.8999 10.875 17.1999 10.875 19.9999C10.875 22.7999 13.175 25.0999 15.975 25.0999H25.775C28.575 25.0999 30.875 22.7999 30.875 19.9999C30.875 17.1999 28.575 14.8999 25.775 14.8999ZM25.775 23.0999H15.975C14.275 23.0999 12.875 21.6999 12.875 19.9999C12.875 18.2999 14.275 16.8999 15.975 16.8999H25.775C27.475 16.8999 28.875 18.2999 28.875 19.9999C28.875 21.6999 27.475 23.0999 25.775 23.0999Z"
      fill="#333333"
    />
  </svg>
);

export const ButtonIcon = ({ className = "" }) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.9749 11H8.7749C8.1749 11 7.7749 11.4 7.7749 12C7.7749 12.6 8.1749 13 8.7749 13H17.0749C17.6749 13 18.0749 12.6 18.0749 12C17.9749 11.4 17.5749 11 16.9749 11Z"
      fill="#333333"
    />
    <path
      d="M17.775 6.8999H7.975C5.175 6.8999 2.875 9.1999 2.875 11.9999C2.875 14.7999 5.175 17.0999 7.975 17.0999H17.775C20.575 17.0999 22.875 14.7999 22.875 11.9999C22.875 9.1999 20.575 6.8999 17.775 6.8999ZM17.775 15.0999H7.975C6.275 15.0999 4.875 13.6999 4.875 11.9999C4.875 10.2999 6.275 8.8999 7.975 8.8999H17.775C19.475 8.8999 20.875 10.2999 20.875 11.9999C20.875 13.6999 19.475 15.0999 17.775 15.0999Z"
      fill="#333333"
    />
  </svg>
);

export const StyleIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="22"
      height="22"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M18.3359 6.26203C18.336 6.25206 18.3361 6.24028 18.3361 6.22847C18.3361 5.52443 18.0486 4.88754 17.5845 4.42894L17.5842 4.42872C17.1091 3.9727 16.4628 3.69189 15.7509 3.69189C15.0391 3.69189 14.3927 3.9727 13.9167 4.42962L13.9176 4.42877L7.86759 10.4788H7.6659C5.51024 10.5385 3.77882 12.2731 3.72433 14.4245L3.72425 14.4296L3.66925 17.4179C3.66907 17.4249 3.66895 17.4331 3.66895 17.4412C3.66895 17.6932 3.77057 17.9214 3.93514 18.0871L3.93509 18.0871C4.10499 18.2406 4.33122 18.3346 4.57945 18.3346C4.58173 18.3346 4.58401 18.3346 4.58629 18.3346H4.58594L7.57429 18.2796C9.73081 18.225 11.4654 16.4936 11.525 14.3435L11.5251 14.3379V14.1271L17.5843 8.07711C18.0484 7.62109 18.3361 6.98669 18.3361 6.28514C18.3361 6.27707 18.336 6.26899 18.336 6.26091V6.26216L18.3359 6.26203ZM7.56509 16.4462L5.50259 16.5012V14.457C5.52322 13.2579 6.50016 12.2937 7.70229 12.2937C7.70238 12.2937 7.70251 12.2937 7.70259 12.2937C7.70268 12.2937 7.70281 12.2937 7.70294 12.2937C8.79142 12.2937 9.67379 13.176 9.67379 14.2645C9.67379 14.2774 9.67366 14.2903 9.67344 14.3031V14.3012C9.64452 15.4613 8.72186 16.3968 7.56961 16.446L7.56509 16.4461V16.4462ZM16.2918 6.77538L10.911 12.1562C10.7626 11.9369 10.6058 11.7452 10.4335 11.5687L10.4343 11.5695C10.26 11.3946 10.068 11.2376 9.86117 11.1012L9.84764 11.0928L15.2285 5.72118C15.3665 5.58931 15.5538 5.50814 15.7601 5.50814C15.9664 5.50814 16.1539 5.58931 16.2921 5.72144L16.2918 5.72118C16.4224 5.8549 16.5029 6.03795 16.5029 6.23981C16.5029 6.24759 16.5028 6.25541 16.5026 6.26314V6.26203C16.5026 6.2628 16.5026 6.26366 16.5026 6.26456C16.5026 6.46389 16.422 6.64441 16.2917 6.77538H16.2918Z"
      fill="#333333"
    />
  </svg>
);

export const TIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="22"
      height="22"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M15.5863 5.50098H6.4196C6.17648 5.50098 5.94332 5.59755 5.77142 5.76946C5.59951 5.94137 5.50293 6.17453 5.50293 6.41764C5.50293 6.66076 5.59951 6.89392 5.77142 7.06582C5.94332 7.23773 6.17648 7.33431 6.4196 7.33431H10.0863V15.5843C10.0863 15.8274 10.1828 16.0606 10.3547 16.2325C10.5267 16.4044 10.7598 16.501 11.0029 16.501C11.246 16.501 11.4792 16.4044 11.6511 16.2325C11.823 16.0606 11.9196 15.8274 11.9196 15.5843V7.33431H15.5863C15.8294 7.33431 16.0625 7.23773 16.2344 7.06582C16.4064 6.89392 16.5029 6.66076 16.5029 6.41764C16.5029 6.17453 16.4064 5.94137 16.2344 5.76946C16.0625 5.59755 15.8294 5.50098 15.5863 5.50098Z"
      fill="#333333"
    />
  </svg>
);

export const IconGeneral = ({
  className = "",
  width = 22,
  height = 22,
  fillColor = "#333333",
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="22"
      height="22"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M18.3363 7.49947V2.75114C18.3363 2.50802 18.2398 2.27487 18.0679 2.10296C17.896 1.93105 17.6628 1.83447 17.4197 1.83447C17.1766 1.83447 16.9434 1.93105 16.7715 2.10296C16.5996 2.27487 16.503 2.50802 16.503 2.75114V7.49947C15.9721 7.69216 15.5134 8.04363 15.1893 8.50612C14.8651 8.96862 14.6912 9.5197 14.6912 10.0845C14.6912 10.6492 14.8651 11.2003 15.1893 11.6628C15.5134 12.1253 15.9721 12.4768 16.503 12.6695V19.2511C16.503 19.4943 16.5996 19.7274 16.7715 19.8993C16.9434 20.0712 17.1766 20.1678 17.4197 20.1678C17.6628 20.1678 17.896 20.0712 18.0679 19.8993C18.2398 19.7274 18.3363 19.4943 18.3363 19.2511V12.6695C18.8672 12.4768 19.3259 12.1253 19.6501 11.6628C19.9742 11.2003 20.1481 10.6492 20.1481 10.0845C20.1481 9.5197 19.9742 8.96862 19.6501 8.50612C19.3259 8.04363 18.8672 7.69216 18.3363 7.49947ZM17.4197 11.0011C17.2384 11.0011 17.0612 10.9474 16.9104 10.8467C16.7597 10.7459 16.6422 10.6028 16.5728 10.4353C16.5034 10.2678 16.4853 10.0835 16.5206 9.90564C16.556 9.72782 16.6433 9.56449 16.7715 9.43629C16.8997 9.30809 17.063 9.22079 17.2408 9.18542C17.4187 9.15005 17.603 9.1682 17.7705 9.23758C17.938 9.30696 18.0811 9.42445 18.1819 9.5752C18.2826 9.72594 18.3363 9.90317 18.3363 10.0845C18.3363 10.3276 18.2398 10.5607 18.0679 10.7327C17.896 10.9046 17.6628 11.0011 17.4197 11.0011ZM11.9197 12.9995V2.75114C11.9197 2.50802 11.8231 2.27487 11.6512 2.10296C11.4793 1.93105 11.2461 1.83447 11.003 1.83447C10.7599 1.83447 10.5267 1.93105 10.3548 2.10296C10.1829 2.27487 10.0863 2.50802 10.0863 2.75114V12.9995C9.55546 13.1922 9.09677 13.5436 8.77262 14.0061C8.44847 14.4686 8.27458 15.0197 8.27458 15.5845C8.27458 16.1492 8.44847 16.7003 8.77262 17.1628C9.09677 17.6253 9.55546 17.9768 10.0863 18.1695V19.2511C10.0863 19.4943 10.1829 19.7274 10.3548 19.8993C10.5267 20.0712 10.7599 20.1678 11.003 20.1678C11.2461 20.1678 11.4793 20.0712 11.6512 19.8993C11.8231 19.7274 11.9197 19.4943 11.9197 19.2511V18.1695C12.4506 17.9768 12.9093 17.6253 13.2334 17.1628C13.5576 16.7003 13.7315 16.1492 13.7315 15.5845C13.7315 15.0197 13.5576 14.4686 13.2334 14.0061C12.9093 13.5436 12.4506 13.1922 11.9197 12.9995ZM11.003 16.5011C10.8217 16.5011 10.6445 16.4474 10.4937 16.3467C10.343 16.2459 10.2255 16.1028 10.1561 15.9353C10.0867 15.7678 10.0686 15.5835 10.104 15.4056C10.1393 15.2278 10.2266 15.0645 10.3548 14.9363C10.483 14.8081 10.6464 14.7208 10.8242 14.6854C11.002 14.65 11.1863 14.6682 11.3538 14.7376C11.5213 14.807 11.6645 14.9245 11.7652 15.0752C11.8659 15.2259 11.9197 15.4032 11.9197 15.5845C11.9197 15.8276 11.8231 16.0607 11.6512 16.2327C11.4793 16.4046 11.2461 16.5011 11.003 16.5011ZM5.50301 5.66614V2.75114C5.50301 2.50802 5.40644 2.27487 5.23453 2.10296C5.06262 1.93105 4.82946 1.83447 4.58635 1.83447C4.34323 1.83447 4.11007 1.93105 3.93817 2.10296C3.76626 2.27487 3.66968 2.50802 3.66968 2.75114V5.66614C3.13879 5.85883 2.6801 6.2103 2.35595 6.67279C2.0318 7.13528 1.85791 7.68636 1.85791 8.25114C1.85791 8.81592 2.0318 9.367 2.35595 9.82949C2.6801 10.292 3.13879 10.6435 3.66968 10.8361V19.2511C3.66968 19.4943 3.76626 19.7274 3.93817 19.8993C4.11007 20.0712 4.34323 20.1678 4.58635 20.1678C4.82946 20.1678 5.06262 20.0712 5.23453 19.8993C5.40644 19.7274 5.50301 19.4943 5.50301 19.2511V10.8361C6.0339 10.6435 6.49259 10.292 6.81674 9.82949C7.14089 9.367 7.31478 8.81592 7.31478 8.25114C7.31478 7.68636 7.14089 7.13528 6.81674 6.67279C6.49259 6.2103 6.0339 5.85883 5.50301 5.66614ZM4.58635 9.16781C4.40505 9.16781 4.22782 9.11404 4.07707 9.01332C3.92633 8.91259 3.80884 8.76943 3.73946 8.60193C3.67008 8.43443 3.65192 8.25012 3.68729 8.07231C3.72266 7.89449 3.80997 7.73116 3.93817 7.60296C4.06636 7.47476 4.2297 7.38746 4.40751 7.35209C4.58533 7.31672 4.76964 7.33487 4.93714 7.40425C5.10464 7.47363 5.2478 7.59112 5.34853 7.74187C5.44925 7.89261 5.50301 8.06984 5.50301 8.25114C5.50301 8.49425 5.40644 8.72741 5.23453 8.89932C5.06262 9.07123 4.82946 9.16781 4.58635 9.16781Z"
      fill={fillColor}
    />
  </svg>
);

export const ParagraphIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="22"
      height="22"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M11.0026 5.50114H8.2526C8.00949 5.50114 7.77633 5.59772 7.60442 5.76962C7.43251 5.94153 7.33594 6.17469 7.33594 6.41781V15.5845C7.33594 15.8276 7.43251 16.0607 7.60442 16.2327C7.77633 16.4046 8.00949 16.5011 8.2526 16.5011C8.49572 16.5011 8.72888 16.4046 8.90078 16.2327C9.07269 16.0607 9.16927 15.8276 9.16927 15.5845V12.8345H11.0026C11.9751 12.8345 12.9077 12.4482 13.5953 11.7605C14.283 11.0729 14.6693 10.1403 14.6693 9.16781C14.6693 8.19535 14.283 7.26271 13.5953 6.57508C12.9077 5.88745 11.9751 5.50114 11.0026 5.50114ZM11.0026 11.0011H9.16927V7.33447H11.0026C11.4888 7.33447 11.9551 7.52763 12.299 7.87144C12.6428 8.21526 12.8359 8.68158 12.8359 9.16781C12.8359 9.65404 12.6428 10.1204 12.299 10.4642C11.9551 10.808 11.4888 11.0011 11.0026 11.0011ZM17.4193 1.83447H4.58594C3.85659 1.83447 3.15712 2.1242 2.64139 2.63993C2.12567 3.15565 1.83594 3.85513 1.83594 4.58447V17.4178C1.83594 18.1472 2.12567 18.8466 2.64139 19.3623C3.15712 19.8781 3.85659 20.1678 4.58594 20.1678H17.4193C18.1486 20.1678 18.8481 19.8781 19.3638 19.3623C19.8795 18.8466 20.1693 18.1472 20.1693 17.4178V4.58447C20.1693 3.85513 19.8795 3.15565 19.3638 2.63993C18.8481 2.1242 18.1486 1.83447 17.4193 1.83447ZM18.3359 17.4178C18.3359 17.6609 18.2394 17.8941 18.0675 18.066C17.8955 18.2379 17.6624 18.3345 17.4193 18.3345H4.58594C4.34282 18.3345 4.10966 18.2379 3.93776 18.066C3.76585 17.8941 3.66927 17.6609 3.66927 17.4178V4.58447C3.66927 4.34136 3.76585 4.1082 3.93776 3.93629C4.10966 3.76438 4.34282 3.66781 4.58594 3.66781H17.4193C17.6624 3.66781 17.8955 3.76438 18.0675 3.93629C18.2394 4.1082 18.3359 4.34136 18.3359 4.58447V17.4178Z"
      fill="#333333"
    />
  </svg>
);

export const BackArrow = ({ className = "" }) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8524 3.05536L6.7614 11.8299C6.48453 12.1056 6.46825 12.5424 6.71254 12.8371L6.7614 12.8906L15.852 21.941C15.8894 21.9783 15.9402 21.9993 15.9931 21.9993H17.5564C17.6669 21.9993 17.7564 21.9097 17.7564 21.7993C17.7564 21.7461 17.7352 21.6951 17.6976 21.6575L8.38967 12.3901L17.6879 3.34261C17.7671 3.26558 17.7688 3.13896 17.6918 3.05979C17.6541 3.0211 17.6024 2.99927 17.5484 2.99927H15.9913C15.9395 2.99927 15.8897 3.01938 15.8524 3.05536Z"
      fill="#333333"
    />
  </svg>
);

export const SquareIcon = ({ className }) => (
  <svg
    className={className}
    width="77"
    height="77"
    viewBox="0 0 77 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect
      width="77"
      height="77"
      fill="url(#patternr0)"
    />
    <defs>
      <pattern
        id="patternr0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_7831_166007"
          transform="scale(0.00438596)"
        />
      </pattern>
      <image
        id="image0_7831_166007"
        width="228"
        height="228"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAADkCAYAAACIV4iNAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF/SURBVHgB7dWxDcIAEATBNyKjG9fgnBqojBpozBmxiSFFQis0k/3nq5sBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBby75uxwAJpwEyBAkhgoSQ8+fj+bgP8BuX6+3ttpAQIkgIESSECBJCBAkhgoQQQUKIICFEkBAiSAgRJIQIEkIECSGChBBBQoggIUSQECJICBEkhAgSQgQJIYKEEEFCiCAhRJAQIkgIESSECBJCBAkhgoQQQUKIICFEkBAiSAgRJIQIEkIECSGChBBBQoggIUSQECJICBEkhAgSQgQJIYKEEEFCiCAhRJAQIkgIESSELPu6HQMkWEgIESSECBIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIB/8gIBwgg/tcfD/QAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
);

export const RoundedIcon = ({ className }) => (
  <svg
    className={className}
    width="77"
    height="77"
    viewBox="0 0 77 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect
      width="77"
      height="77"
      fill="url(#patternr1)"
    />
    <defs>
      <pattern
        id="patternr1"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_7831_166017"
          transform="scale(0.00438596)"
        />
      </pattern>
      <image
        id="image0_7831_166017"
        width="228"
        height="228"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAADkCAYAAACIV4iNAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATYSURBVHgB7ds/bBNXHMDx985JW8ESKsSInK1DKwwLDEgEIaouFNiAhYHOhb1DYewGeyvBUkZALFVRIZUYYCGuYKATFlspVbKABLbves9R0Nlx+GujGz4fyQp+d5ftq9/duxACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfKr7ticuthbmQzR7JY74vFrFVLjXLz1wARq2Un04RinYWG4uh//Lalvbiyttc+MYgl1vfNHtZ90wjxJNBgPBeyjgvZvnsuS3t3zqvO2/DIFcn4syPRQhnAjARZU/ns7x3bqOJOTbINBWLrH+rvLwZgAmLnZg39o+bluuCXG4dbBVZuDIuxmLzptD79mDof/lFyLdtDUX5AYbFZ89D9uhxmLlzL2R3l0L25Om4szq9PBzd1r7RHlqtftloMqbwXpw+NQgReDczN2+H2cvXxoS5flK+CjI9MxbZ7NJojGkivjx2ZDAdgfeTpuYnl6+Gmes3Ro+UUXZ3rj1TZq/Wyw2c0Ri7xw+HF6dOiBE+UGroxXcnBk2NHGnmg/ZWDSbk6q1q71H1tDQZU4zAZH3686/rJmXMZ+bTretgQvZj92z1YHpmTLepwOS9PH5ksClalZfv+tPPuPrsOLNcPfji+1Ohd2BvAKaj8eBh+OyHn6pLKzHvzWf9bHZoFKbpKEaYrvTGYmRvZi61mIUiX6iu9nbvDMD0dQ8dHPreCPm+LItxR3Wxv2dXAKYv/2r4vX5RxFba1GkOnTS/PQDTN7qxU77zaKYgh/4Hh3eO8HGM+dPTuSwAtSFIqBFBQo0IEmpEkFAjgoQaESTUiCChRgQJNSJIqBFBQo0IEmpEkFAjgoQaESTUiCChRgQJNSJIqBFBQo0IEmpEkFAjgoQaESTUiCChRgQJNSJIqBFBQo0IEmpEkFAjKciV6kL852kApi8+ez66tJKC7FRXsn8FCR9D9ujx8EIROllRhL+GTrr/MADT17hzb+h7jEU7K2JcrC7OXr8RgOlr3F0aXsjDYtbIu1dD5Tky3dc2HpiSME0zN2+H7Mno42H/WralvbhShOJSdfnTC7+Me+AEJiC1NXv52vBaKC6mFgevPbK8f37oYFnu6AXAZKS21k3HvH8u/RgEWZbZKafkhaGLrv8uSpiw1FRqqyq1lxpM/45ri8uthbkiNpbKrZ5m9eTuoa9D9/jhUGzeFID3s3abOhpjKIrO50t/zL86r3qsjLJZRnlrNMpi29bw8tjh0DuwNwDvJm2SflLuy6y7TS1jjEV//9p0TOLoxU9aC62Z2LgyGuXg+jLM/u6dobdnV8jnt5uaMEbag0nxZff/HkzEsRukqzEeLWNsD1077hduNCmBCRgzGdfE1133364D52OIpwMwEWkDp3yrcTa94hh3PL7pF6RpmcfG2RjjyQC8uyKsFLG4lF4vjpuKVW8Mck3ahe2H7EgZ5kI5NXeUS83y6rkADCsGf/nWKSNsF3n2ZyN0r240EQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmLz/Aa1een79WpebAAAAAElFTkSuQmCC"
      />
    </defs>
  </svg>
);

export const CustomIcon = ({ className }) => (
  <svg
    className={className}
    width="77"
    height="77"
    viewBox="0 0 77 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect
      width="77"
      height="77"
      fill="url(#patternr2)"
    />
    <defs>
      <pattern
        id="patternr2"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_7831_166027"
          transform="scale(0.00438596)"
        />
      </pattern>
      <image
        id="image0_7831_166027"
        width="228"
        height="228"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const SiteIcon = ({ className = "", fillColor = "#333333" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M21.32 9.55L19.43 8.92L20.32 7.14C20.4102 6.95369 20.4404 6.74397 20.4064 6.53978C20.3723 6.33558 20.2758 6.14699 20.13 6L18 3.87C17.8522 3.72209 17.6618 3.62421 17.4555 3.59013C17.2493 3.55605 17.0375 3.58748 16.85 3.68L15.07 4.57L14.44 2.68C14.3735 2.483 14.2472 2.31163 14.0787 2.18975C13.9102 2.06787 13.7079 2.00155 13.5 2H10.5C10.2904 1.99946 10.0858 2.06482 9.91537 2.18685C9.7449 2.30887 9.61709 2.48138 9.55 2.68L8.92 4.57L7.14 3.68C6.95369 3.58978 6.74397 3.55961 6.53978 3.59364C6.33558 3.62767 6.14699 3.72423 6 3.87L3.87 6C3.72209 6.14777 3.62421 6.33818 3.59013 6.54446C3.55605 6.75074 3.58748 6.96251 3.68 7.15L4.57 8.93L2.68 9.56C2.483 9.62654 2.31163 9.75283 2.18975 9.92131C2.06787 10.0898 2.00155 10.2921 2 10.5V13.5C1.99946 13.7096 2.06482 13.9142 2.18685 14.0846C2.30887 14.2551 2.48138 14.3829 2.68 14.45L4.57 15.08L3.68 16.86C3.58978 17.0463 3.55961 17.256 3.59364 17.4602C3.62767 17.6644 3.72423 17.853 3.87 18L6 20.13C6.14777 20.2779 6.33818 20.3758 6.54446 20.4099C6.75074 20.444 6.96251 20.4125 7.15 20.32L8.93 19.43L9.56 21.32C9.62709 21.5186 9.7549 21.6911 9.92537 21.8132C10.0958 21.9352 10.3004 22.0005 10.51 22H13.51C13.7196 22.0005 13.9242 21.9352 14.0946 21.8132C14.2651 21.6911 14.3929 21.5186 14.46 21.32L15.09 19.43L16.87 20.32C17.0551 20.4079 17.2628 20.4369 17.4649 20.4029C17.667 20.3689 17.8538 20.2737 18 20.13L20.13 18C20.2779 17.8522 20.3758 17.6618 20.4099 17.4555C20.444 17.2493 20.4125 17.0375 20.32 16.85L19.43 15.07L21.32 14.44C21.517 14.3735 21.6884 14.2472 21.8103 14.0787C21.9321 13.9102 21.9985 13.7079 22 13.5V10.5C22.0005 10.2904 21.9352 10.0858 21.8132 9.91537C21.6911 9.7449 21.5186 9.61709 21.32 9.55ZM20 12.78L18.8 13.18C18.5241 13.2695 18.2709 13.418 18.0581 13.6151C17.8452 13.8122 17.6778 14.0533 17.5675 14.3216C17.4571 14.5899 17.4064 14.879 17.419 15.1688C17.4315 15.4586 17.5069 15.7422 17.64 16L18.21 17.14L17.11 18.24L16 17.64C15.7436 17.5122 15.4627 17.4411 15.1763 17.4313C14.89 17.4215 14.6049 17.4734 14.3403 17.5834C14.0758 17.6934 13.8379 17.8589 13.6429 18.0688C13.4479 18.2787 13.3003 18.5281 13.21 18.8L12.81 20H11.22L10.82 18.8C10.7305 18.5241 10.582 18.2709 10.3849 18.0581C10.1878 17.8452 9.94671 17.6778 9.67842 17.5675C9.41014 17.4571 9.12105 17.4064 8.83123 17.419C8.5414 17.4315 8.25777 17.5069 8 17.64L6.86 18.21L5.76 17.11L6.36 16C6.4931 15.7422 6.56852 15.4586 6.58105 15.1688C6.59358 14.879 6.5429 14.5899 6.43254 14.3216C6.32218 14.0533 6.15478 13.8122 5.94195 13.6151C5.72912 13.418 5.47595 13.2695 5.2 13.18L4 12.78V11.22L5.2 10.82C5.47595 10.7305 5.72912 10.582 5.94195 10.3849C6.15478 10.1878 6.32218 9.94671 6.43254 9.67842C6.5429 9.41014 6.59358 9.12105 6.58105 8.83123C6.56852 8.5414 6.4931 8.25777 6.36 8L5.79 6.89L6.89 5.79L8 6.36C8.25777 6.4931 8.5414 6.56852 8.83123 6.58105C9.12105 6.59358 9.41014 6.5429 9.67842 6.43254C9.94671 6.32218 10.1878 6.15478 10.3849 5.94195C10.582 5.72912 10.7305 5.47595 10.82 5.2L11.22 4H12.78L13.18 5.2C13.2695 5.47595 13.418 5.72912 13.6151 5.94195C13.8122 6.15478 14.0533 6.32218 14.3216 6.43254C14.5899 6.5429 14.879 6.59358 15.1688 6.58105C15.4586 6.56852 15.7422 6.4931 16 6.36L17.14 5.79L18.24 6.89L17.64 8C17.5122 8.25645 17.4411 8.53735 17.4313 8.82369C17.4215 9.11003 17.4734 9.39513 17.5834 9.65969C17.6934 9.92424 17.8589 10.1621 18.0688 10.3571C18.2787 10.5521 18.5281 10.6997 18.8 10.79L20 11.19V12.78ZM12 8C11.2089 8 10.4355 8.2346 9.77772 8.67413C9.11993 9.11365 8.60724 9.73836 8.30448 10.4693C8.00173 11.2002 7.92252 12.0044 8.07686 12.7804C8.2312 13.5563 8.61217 14.269 9.17158 14.8284C9.73099 15.3878 10.4437 15.7688 11.2196 15.9231C11.9956 16.0775 12.7998 15.9983 13.5307 15.6955C14.2616 15.3928 14.8864 14.8801 15.3259 14.2223C15.7654 13.5645 16 12.7911 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17158C14.0783 8.42143 13.0609 8 12 8ZM12 14C11.6044 14 11.2178 13.8827 10.8889 13.6629C10.56 13.4432 10.3036 13.1308 10.1522 12.7654C10.0009 12.3999 9.96126 11.9978 10.0384 11.6098C10.1156 11.2219 10.3061 10.8655 10.5858 10.5858C10.8655 10.3061 11.2219 10.1156 11.6098 10.0384C11.9978 9.96126 12.3999 10.0009 12.7654 10.1522C13.1308 10.3036 13.4432 10.56 13.6629 10.8889C13.8827 11.2178 14 11.6044 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const AwardIcon = ({ className = "", fillColor = "#333333" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M20.87 17.25L18.16 12.57C18.7145 11.5515 19.0034 10.4097 19 9.25C19 7.39348 18.2625 5.61301 16.9497 4.30025C15.637 2.9875 13.8565 2.25 12 2.25C10.1435 2.25 8.363 2.9875 7.05025 4.30025C5.73749 5.61301 5 7.39348 5 9.25C4.99655 10.4097 5.28545 11.5515 5.84 12.57L3.13 17.25C3.04206 17.4023 2.99584 17.5751 2.99602 17.751C2.99619 17.9269 3.04275 18.0996 3.13099 18.2517C3.21923 18.4039 3.34603 18.53 3.4986 18.6175C3.65118 18.705 3.82412 18.7507 4 18.75H6.87L8.33 21.21C8.37921 21.2915 8.43983 21.3656 8.51 21.43C8.69537 21.6087 8.94253 21.709 9.2 21.71H9.34C9.49097 21.6893 9.63522 21.6345 9.76174 21.5495C9.88825 21.4646 9.99369 21.3519 10.07 21.22L12 17.9L13.93 21.25C14.0074 21.38 14.1134 21.4908 14.2398 21.5739C14.3663 21.6571 14.5099 21.7104 14.66 21.73H14.8C15.0609 21.7316 15.3121 21.6311 15.5 21.45C15.5673 21.3893 15.6246 21.3184 15.67 21.24L17.13 18.78H20C20.1762 18.7807 20.3495 18.7348 20.5023 18.647C20.655 18.5592 20.7819 18.4326 20.87 18.28C20.9634 18.1245 21.0128 17.9464 21.0128 17.765C21.0128 17.5836 20.9634 17.4055 20.87 17.25ZM9.19 18.78L8.3 17.29C8.21236 17.1422 8.08811 17.0194 7.93922 16.9336C7.79033 16.8478 7.62184 16.8018 7.45 16.8H5.72L7.15 14.32C8.13472 15.2689 9.37581 15.9085 10.72 16.16L9.19 18.78ZM12 14.25C11.0111 14.25 10.0444 13.9568 9.22215 13.4073C8.3999 12.8579 7.75904 12.077 7.3806 11.1634C7.00216 10.2498 6.90314 9.24445 7.09607 8.27455C7.289 7.30464 7.7652 6.41373 8.46446 5.71447C9.16373 5.0152 10.0546 4.539 11.0245 4.34607C11.9945 4.15315 12.9998 4.25216 13.9134 4.6306C14.827 5.00904 15.6079 5.6499 16.1573 6.47215C16.7068 7.29439 17 8.26109 17 9.25C17 10.5761 16.4732 11.8479 15.5355 12.7855C14.5978 13.7232 13.3261 14.25 12 14.25ZM16.55 16.8C16.3782 16.8018 16.2097 16.8478 16.0608 16.9336C15.9119 17.0194 15.7876 17.1422 15.7 17.29L14.81 18.78L13.29 16.13C14.6295 15.8734 15.866 15.2343 16.85 14.29L18.28 16.77L16.55 16.8Z"
      fill={fillColor}
    />
  </svg>
);

export const NoShadowSquareIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 77 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="1"
      y="28.3684"
      width="75"
      height="20"
      fill="white"
    />
    <rect
      x="1"
      y="28.3684"
      width="75"
      height="20"
      stroke="black"
      strokeWidth="2"
    />
  </svg>
);

export const NoShadowRoundedIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 77 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="1"
      y="28.3684"
      width="75"
      height="20"
      rx="4"
      fill="white"
    />
    <rect
      x="1"
      y="28.3684"
      width="75"
      height="20"
      rx="4"
      stroke="black"
      strokeWidth="2"
    />
  </svg>
);

export const NoShadowCustomIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 77 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="1"
      y="28.3684"
      width="75"
      height="20"
      rx="10"
      fill={fillColor}
    />
    <rect
      x="1"
      y="28.3684"
      width="75"
      height="20"
      rx="10"
      stroke="black"
      strokeWidth="2"
    />
  </svg>
);

export const SoftShadowSquareIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 81 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g filter="url(#filter0_d_23619_905774)">
      <rect
        x="5"
        y="29.5"
        width="71"
        height="18"
        fill="white"
      />
      <rect
        x="4"
        y="28.5"
        width="73"
        height="20"
        stroke="black"
        strokeWidth="2"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_23619_905774"
        x="0"
        y="26.5"
        width="81"
        height="28"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_23619_905774"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_23619_905774"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const SoftShadowRoundedIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 81 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g filter="url(#filter0_d_23619_905780)">
      <rect
        x="5"
        y="29.5"
        width="71"
        height="18"
        rx="4"
        fill="white"
      />
      <rect
        x="4"
        y="28.5"
        width="73"
        height="20"
        rx="5"
        stroke="black"
        strokeWidth="2"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_23619_905780"
        x="0"
        y="26.5"
        width="81"
        height="28"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_23619_905780"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_23619_905780"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const SoftShadowCustomIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 81 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g filter="url(#filter0_d_23619_905784)">
      <rect
        x="5"
        y="29.5"
        width="71"
        height="18"
        rx="9"
        fill="white"
      />
      <rect
        x="4"
        y="28.5"
        width="73"
        height="20"
        rx="10"
        stroke="black"
        strokeWidth="2"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_23619_905784"
        x="0"
        y="26.5"
        width="81"
        height="28"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_23619_905784"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_23619_905784"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const HardShadowSquareIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 77 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="2.75"
      y="31.2873"
      width="73.5"
      height="18.4254"
      fill="black"
    />
    <rect
      x="2.75"
      y="31.2873"
      width="73.5"
      height="18.4254"
      stroke="black"
      strokeWidth="1.5"
    />
    <rect
      x="0.75"
      y="29.2873"
      width="73.5"
      height="18.4254"
      fill="white"
    />
    <rect
      x="0.75"
      y="29.2873"
      width="73.5"
      height="18.4254"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);

export const HardShadowRoundedIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 77 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="2.75"
      y="31.2873"
      width="73.5"
      height="18.5"
      rx="3.25"
      fill="black"
    />
    <rect
      x="2.75"
      y="31.2873"
      width="73.5"
      height="18.5"
      rx="3.25"
      stroke="black"
      strokeWidth="1.5"
    />
    <rect
      x="0.75"
      y="29.2873"
      width="73.5"
      height="18.5"
      rx="3.25"
      fill="white"
    />
    <rect
      x="0.75"
      y="29.2873"
      width="73.5"
      height="18.5"
      rx="3.25"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);

export const HardShadowCustomIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 77 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="2.75"
      y="31.2873"
      width="73.5"
      height="18.5"
      rx="9.25"
      fill="black"
    />
    <rect
      x="2.75"
      y="31.2873"
      width="73.5"
      height="18.5"
      rx="9.25"
      stroke="black"
      strokeWidth="1.5"
    />
    <rect
      x="0.75"
      y="29.2873"
      width="73.5"
      height="18.5"
      rx="9.25"
      fill="white"
    />
    <rect
      x="0.75"
      y="29.2873"
      width="73.5"
      height="18.5"
      rx="9.25"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);

export const DashRoundedIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 78 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="2.5"
      y="27.3684"
      width="73"
      height="20"
      rx="5"
      fill="white"
    />
    <rect
      x="2.5"
      y="27.3684"
      width="73"
      height="20"
      rx="5"
      stroke="black"
      strokeWidth="2"
      strokeDasharray="12 3"
    />
  </svg>
);
export const DotRoundedIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 78 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="3.5"
      y="28.5"
      width="71"
      height="20"
      rx="4"
      fill="white"
    />
    <rect
      x="3.5"
      y="28.5"
      width="71"
      height="20"
      rx="4"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="1 4"
    />
  </svg>
);

export const DotSquareIcon = ({
  className = "",
  fillColor = "#fff",
  width = 77,
  height = 77,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 77 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="3"
      y="28.5"
      width="71"
      height="20"
      rx="10"
      fill="white"
    />
    <rect
      x="3"
      y="28.5"
      width="71"
      height="20"
      rx="10"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="1 4"
    />
  </svg>
);
export const AwardIconV2 = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="40"
        height="40"
        rx="8"
        fill="#F5F5F5"
      />
      <path
        d="M28.8701 25.25L26.1601 20.57C26.7146 19.5515 27.0035 18.4097 27.0001 17.25C27.0001 15.3935 26.2626 13.613 24.9498 12.3003C23.6371 10.9875 21.8566 10.25 20.0001 10.25C18.1436 10.25 16.3631 10.9875 15.0503 12.3003C13.7376 13.613 13.0001 15.3935 13.0001 17.25C12.9966 18.4097 13.2855 19.5515 13.8401 20.57L11.1301 25.25C11.0421 25.4023 10.9959 25.5751 10.9961 25.751C10.9963 25.9269 11.0428 26.0996 11.1311 26.2517C11.2193 26.4039 11.3461 26.53 11.4987 26.6175C11.6513 26.705 11.8242 26.7507 12.0001 26.75H14.8701L16.3301 29.21C16.3793 29.2915 16.4399 29.3656 16.5101 29.43C16.6955 29.6087 16.9426 29.709 17.2001 29.71H17.3401C17.491 29.6893 17.6353 29.6345 17.7618 29.5495C17.8883 29.4646 17.9938 29.3519 18.0701 29.22L20.0001 25.9L21.9301 29.25C22.0075 29.38 22.1134 29.4908 22.2399 29.5739C22.3663 29.6571 22.51 29.7104 22.6601 29.73H22.8001C23.061 29.7316 23.3122 29.6311 23.5001 29.45C23.5673 29.3893 23.6247 29.3184 23.6701 29.24L25.1301 26.78H28.0001C28.1763 26.7807 28.3495 26.7348 28.5023 26.647C28.6551 26.5592 28.782 26.4326 28.8701 26.28C28.9635 26.1245 29.0129 25.9464 29.0129 25.765C29.0129 25.5836 28.9635 25.4055 28.8701 25.25ZM17.1901 26.78L16.3001 25.29C16.2124 25.1422 16.0882 25.0194 15.9393 24.9336C15.7904 24.8478 15.6219 24.8018 15.4501 24.8H13.7201L15.1501 22.32C16.1348 23.2689 17.3759 23.9085 18.7201 24.16L17.1901 26.78ZM20.0001 22.25C19.0112 22.25 18.0445 21.9568 17.2222 21.4073C16.4 20.8579 15.7591 20.077 15.3807 19.1634C15.0022 18.2498 14.9032 17.2445 15.0961 16.2745C15.2891 15.3046 15.7653 14.4137 16.4645 13.7145C17.1638 13.0152 18.0547 12.539 19.0246 12.3461C19.9945 12.1531 20.9999 12.2522 21.9135 12.6306C22.8271 13.009 23.608 13.6499 24.1574 14.4721C24.7068 15.2944 25.0001 16.2611 25.0001 17.25C25.0001 18.5761 24.4733 19.8479 23.5356 20.7855C22.5979 21.7232 21.3262 22.25 20.0001 22.25ZM24.5501 24.8C24.3782 24.8018 24.2097 24.8478 24.0609 24.9336C23.912 25.0194 23.7877 25.1422 23.7001 25.29L22.8101 26.78L21.2901 24.13C22.6296 23.8734 23.866 23.2343 24.8501 22.29L26.2801 24.77L24.5501 24.8Z"
        fill="#333333"
      />
    </svg>
  );
};
export const SiteIconV2 = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="40"
        height="40"
        rx="8"
        fill="#F5F5F5"
      />
      <path
        d="M29.4102 16.6401C29.4102 16.6401 29.4102 16.6401 29.4102 16.5901C28.7056 14.6663 27.4271 13.0054 25.7477 11.832C24.0683 10.6586 22.0689 10.0293 20.0202 10.0293C17.9714 10.0293 15.9721 10.6586 14.2927 11.832C12.6133 13.0054 11.3348 14.6663 10.6302 16.5901C10.6302 16.5901 10.6302 16.5901 10.6302 16.6401C9.84332 18.811 9.84332 21.1892 10.6302 23.3601C10.6302 23.3601 10.6302 23.3601 10.6302 23.4101C11.3348 25.3339 12.6133 26.9948 14.2927 28.1683C15.9721 29.3417 17.9714 29.971 20.0202 29.971C22.0689 29.971 24.0683 29.3417 25.7477 28.1683C27.4271 26.9948 28.7056 25.3339 29.4102 23.4101C29.4102 23.4101 29.4102 23.4101 29.4102 23.3601C30.1971 21.1892 30.1971 18.811 29.4102 16.6401ZM12.2602 22.0001C11.9134 20.6893 11.9134 19.3109 12.2602 18.0001H14.1202C13.9602 19.3287 13.9602 20.6716 14.1202 22.0001H12.2602ZM13.0802 24.0001H14.4802C14.7149 24.892 15.0504 25.7542 15.4802 26.5701C14.4995 25.9021 13.6797 25.0242 13.0802 24.0001ZM14.4802 16.0001H13.0802C13.6711 14.9792 14.4804 14.1016 15.4502 13.4301C15.0307 14.2474 14.7053 15.1095 14.4802 16.0001ZM19.0002 27.7001C17.772 26.7988 16.9093 25.4854 16.5702 24.0001H19.0002V27.7001ZM19.0002 22.0001H16.1402C15.9536 20.6733 15.9536 19.3269 16.1402 18.0001H19.0002V22.0001ZM19.0002 16.0001H16.5702C16.9093 14.5149 17.772 13.2014 19.0002 12.3001V16.0001ZM26.9202 16.0001H25.5202C25.2855 15.1083 24.95 14.2461 24.5202 13.4301C25.5009 14.0982 26.3207 14.9761 26.9202 16.0001ZM21.0002 12.3001C22.2284 13.2014 23.091 14.5149 23.4302 16.0001H21.0002V12.3001ZM21.0002 27.7001V24.0001H23.4302C23.091 25.4854 22.2284 26.7988 21.0002 27.7001ZM23.8602 22.0001H21.0002V18.0001H23.8602C24.0468 19.3269 24.0468 20.6733 23.8602 22.0001ZM24.5502 26.5701C24.98 25.7542 25.3155 24.892 25.5502 24.0001H26.9502C26.3507 25.0242 25.5309 25.9021 24.5502 26.5701ZM27.7402 22.0001H25.8802C25.9615 21.3366 26.0016 20.6686 26.0002 20.0001C26.0013 19.3316 25.9612 18.6637 25.8802 18.0001H27.7402C28.087 19.3109 28.087 20.6893 27.7402 22.0001Z"
        fill="#333333"
      />
    </svg>
  );
};

export const IconDocument = ({ className = ''}) => {
  return (
    <svg className={className} width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.2497 21.3529H8.74967C3.77217 21.3529 1.64551 19.2262 1.64551 14.2487V8.7487C1.64551 3.7712 3.77217 1.64453 8.74967 1.64453H14.2497C19.2272 1.64453 21.3538 3.7712 21.3538 8.7487V14.2487C21.3538 19.2262 19.2272 21.3529 14.2497 21.3529ZM8.74967 3.01953C4.52384 3.01953 3.02051 4.52286 3.02051 8.7487V14.2487C3.02051 18.4745 4.52384 19.9779 8.74967 19.9779H14.2497C18.4755 19.9779 19.9788 18.4745 19.9788 14.2487V8.7487C19.9788 4.52286 18.4755 3.01953 14.2497 3.01953H8.74967ZM14.9372 9.4362H8.06217C7.68634 9.4362 7.37467 9.12453 7.37467 8.7487C7.37467 8.37286 7.68634 8.0612 8.06217 8.0612H14.9372C15.313 8.0612 15.6247 8.37286 15.6247 8.7487C15.6247 9.12453 15.313 9.4362 14.9372 9.4362ZM8.06217 14.9362H14.9372C15.313 14.9362 15.6247 14.6245 15.6247 14.2487C15.6247 13.8729 15.313 13.5612 14.9372 13.5612H8.06217C7.68634 13.5612 7.37467 13.8729 7.37467 14.2487C7.37467 14.6245 7.68634 14.9362 8.06217 14.9362Z" fill="#333333"/>
    </svg>
  )
}
